import {
  useGetTargetBuildingRoofs,
  SELECTION_MODE,
  useSelectObject,
} from "../CustomHooks";
import FilledPolygon from "./FilledPolygon";
import { useSelector, useDispatch } from "react-redux";
import { setSelectedRoofs } from "../../redux/pvDesign";
import { reduxLocalStorage } from "../utility/storage";
import { useCallback } from "react";
import { colors } from "../../utils/colors";

export function PVRooftopPolygonsSelection() {
  const { result: roofs } = useGetTargetBuildingRoofs({ isActive: true });
  const project_id = reduxLocalStorage.getItem("project_id");
  const { selectedRoofs, isSelectRoofsOpen } = useSelector(
    (state) => state.pvDesign
  );
  const dispatch = useDispatch();

  const setExternalSelectedObjects = useCallback(
    (roofs) => dispatch(setSelectedRoofs(roofs)),
    [dispatch]
  );

  const { onPointerEnter, onPointerLeave, onSingleClick, getObjectColor } =
    useSelectObject({
      externalSelectedObjects: selectedRoofs,
      setExternalSelectedObjects,
      selectionMode: SELECTION_MODE.MULTIPLE,
      defaultColor: colors.rooftopPolygon(),
    });

  if (!isSelectRoofsOpen) return null;

  const p185 = [393272, 5818692, 32.1];
  const p1360 = [386445, 5818814, 30];
  const p1858 = [388958.25, 5817010, 35.2];

  const translation =
    project_id === "185"
      ? p185
      : project_id === "1360"
      ? p1360
      : project_id === "1858"
      ? p1858
      : [0, 0, 0];

  return roofs?.map((roof) => {
    const verts = roof?.polygon?.map(([x, y, z]) => [
      x - translation[0],
      y - translation[1],
      z - translation[2],
    ]);

    return (
      <FilledPolygon
        verts={verts}
        onPointerEnter={(e) => onPointerEnter(e, roof?.id)}
        onPointerLeave={onPointerLeave}
        color={getObjectColor(roof?.id)}
        onClick={(e) => onSingleClick(e, roof?.id)}
      />
    );
  });
}
